export default "__VITE_ASSET__ByJUOIwK__"